import { type Theme } from '@doxyme/ui-foundation/theme';
import { type CSSObject } from '@emotion/react';

type Return = Record<'container' | 'content', CSSObject>;

export const useBrandedVirtualBackgroundPlaceholderStyles = (
  theme: Theme,
): Return => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
    borderRadius: theme.spacing(2),
    background: theme.virtualBackground.setting.default,
    padding: theme.spacing(4),
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
});
